export default {
  currentUser: {
    userId: "",
    userType: "",
    merchantId: "",
    aliasMerchant: "",
  },
};
